const numberAlignRight = () => ({
  style: {
    textAlign: 'right',
  },
})

const textAlignCenter = () => ({
  style: {
    textAlign: 'center',
  },
})

// Ordena pelo valor do link (children). Sem nota/recebimento a célula é só '-', sem props, e fica
// sempre no fim: o react-table inverte o retorno na ordem decrescente, então `desc` compensa.
const sortByLinkValue = (cellA: any, cellB: any, desc?: boolean) => {
  const valueA = cellA?.props?.children
  const valueB = cellB?.props?.children

  if (valueA === undefined || valueB === undefined) {
    if (valueA === valueB) return 0

    const emptyAfter = valueA === undefined ? 1 : -1
    return desc ? -emptyAfter : emptyAfter
  }

  if (valueA < valueB) return -1
  if (valueA > valueB) return 1

  return 0
}

export default [
  {
    Header: 'Tipo',
    id: 'type',
    accessor: 'type',
    width: 100,
  },
  {
    Header: 'Data movimentação',
    id: 'createdAt',
    accessor: 'createdAt',
    width: 140,
  },
  {
    Header: 'Usuário',
    id: 'user',
    accessor: 'user',
    width: 250,
  },
  {
    Header: 'Quantidade',
    id: 'appliedQuantity',
    accessor: 'appliedQuantity',
    width: 80,
    getProps: numberAlignRight,
  },
  {
    Header: 'Saldo final',
    id: 'balance',
    accessor: 'balance',
    width: 80,
    getProps: numberAlignRight,
  },
  {
    Header: 'Código do pedido',
    id: 'orderCode',
    accessor: 'orderCode',
    width: 160,
    getProps: textAlignCenter,
  },
  {
    Header: 'Nota',
    id: 'invoice',
    accessor: 'invoice',
    width: 290,
    getProps: textAlignCenter,
    sortMethod: sortByLinkValue,
  },
  {
    Header: 'Recebimento',
    id: 'receivement',
    accessor: 'receivement',
    width: 90,
    getProps: textAlignCenter,
    sortMethod: sortByLinkValue,
  },
  {
    Header: '',
    id: 'dumb',
    accessor: 'dumb',
    width: 1,
  },
]
